import type { Option } from '@openx/types/options.ts';
import type { FilterValue } from '../types.ts';

export const isString = (value: unknown): value is string => typeof value === 'string';

export const isStringArray = (value: unknown): value is string[] =>
  Array.isArray(value) && value.every(item => typeof item === 'string');

export const isOption = (value: unknown): value is Option => {
  return typeof value === 'object' && value !== null && 'id' in value && 'name' in value;
};

export const isOptionArray = (value: unknown): value is Option[] => Array.isArray(value) && value.every(isOption);

export const isStringOrUndefinedTuple = (value: unknown): value is [string | undefined, string | undefined] => {
  return Array.isArray(value) && value.length === 2 && value.every(v => typeof v === 'string' || v === undefined);
};

export const getSelectedOption = (val: unknown): string | undefined => {
  if (typeof val === 'string') return val;
  if (Array.isArray(val) && typeof val[0] === 'string') return val[0];

  return undefined;
};

export const getSelectedOptions = (val: FilterValue): string[] | undefined => {
  if (Array.isArray(val) && val.every(v => typeof v === 'string')) return val as string[];

  return undefined;
};

export const getSelectedRangeOptions = (val: FilterValue): [string | undefined, string | undefined] | undefined => {
  if (isStringOrUndefinedTuple(val)) return val;

  return undefined;
};
